import React, { useRef } from "react";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button } from "./Helpers/UIComponents";
import { MultiPurposeInputProps } from "@interfaces/uiElementTypes";
import classNames from "classnames";
import { useOutsideClickDetector } from "@hooks/useOutsideClickDetector";

import UnfoldMoreIcon from "@assets/icons/unfold_more.svg";

const MultiPurposeInput: React.FC<MultiPurposeInputProps> = ({
  label,
  text,
  icon,
  popup,
  isDropdown = false,
  isCounter = false,
  isFilter = false,
  isInput = true,
  count,
  setCount,
  isOpen = false,
  onToggle,
  classNameInput,
  classNameContainer,
  classNameIcon,
  classNameLabel,
  classNameText,
  resetValue,
  disabled,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  useOutsideClickDetector(popupRef, () => {
    if (isOpen && onToggle) {
      onToggle();
    }
  });

  const handlePopupClick = () => {
    if (disabled) return;
    if (isDropdown && onToggle) {
      onToggle();
    }
  };

  const handleIncrement = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isCounter && setCount && count !== undefined) {
      setCount(count + 1);
    }
  };

  const handleDecrement = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isCounter && setCount && count !== undefined && count > 0) {
      setCount(count - 1);
    }
  };

  return (
    <div
      className={classNames(
        "relative w-full min-w-fit",
        { "opacity-50": disabled },
        classNameContainer,
      )}
    >
      <div
        className={classNames("input_container", classNameInput, {
          "!cursor-not-allowed": disabled,
        })}
        onClick={handlePopupClick}
      >
        {icon && (
          <div
            className={`nav_button ml-2 flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full ${classNameIcon}`}
          >
            {icon}
          </div>
        )}
        <div
          className={`flex flex-grow flex-col text-black ${
            label ? "ml-2" : ""
          }`}
        >
          <span
            className={`text-black opacity-35 ${classNameLabel} ${
              text ? "text-sm" : "text-base"
            }`}
          >
            {label}
          </span>
          {text && (
            <span className={`w-full text-black ${classNameText} line-clamp-2`}>
              {text}
            </span>
          )}
        </div>
        {isDropdown && (
          <>
            {isFilter && text && (
              <Button
                className="ml-1"
                onClick={(e) => {
                  e.stopPropagation();
                  resetValue && resetValue();
                }}
              >
                <CloseRoundedIcon sx={{ fontSize: 20 }} />
              </Button>
            )}
            {isInput && (
              <div
                className={`mr-2 flex items-center justify-center ${
                  text ? "" : "ml-2"
                }`}
              >
                <UnfoldMoreIcon className="text-[#929293]" />
              </div>
            )}
          </>
        )}
        {isCounter && (
          <div className="counter_container">
            <Button
              onClick={handleDecrement}
              type="button"
              className="count_button"
            >
              <RemoveRoundedIcon
                sx={{ fontSize: 20 }}
                className="icon_secondary"
              />
            </Button>
            <span className="mx-4 text-lg">{count}</span>
            <Button
              onClick={handleIncrement}
              type="button"
              className="count_button"
            >
              <AddRoundedIcon
                sx={{ fontSize: 20 }}
                className="icon_secondary"
              />
            </Button>
          </div>
        )}
      </div>

      {isDropdown && popup ? popup : null}
    </div>
  );
};

export default MultiPurposeInput;
